import { InjectionToken } from '@angular/core';

export const AppSyncClientOptionsService = new InjectionToken<{ url: string; region: string }>(undefined);
